import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const breakpoints = {
    desktop: '1920px',
    tablet: '1121px',
    mobile: '767px',
};

export const Wrapper = styled.div<{ webpUrl: string }>`
    width: 100%;
    ${({ webpUrl }) => `background-image: image-set(url(${webpUrl}) 1x)`};
    min-height: 447px;
    margin-bottom: 64px;
    padding: 0 90px;
    position: relative;

    @media (min-width: ${breakpoints.desktop}) {
        background-size: cover;
    }
    
    @media (max-width: ${breakpoints.tablet}) {
        padding: 0 0 0 16px;
        height: auto;
    }

    @media (max-width: ${breakpoints.mobile}) {
        margin-bottom: 32px;
        padding: 0;
    }
`;

export const Container = styled(GridContainer)`
    @media (max-width: 1599px) {
        width: 100%;
        max-width: 1360px;
        padding: 0;
    }

    @media (max-width: ${breakpoints.mobile}) {
        padding: 0 16px;
        width:100%;
    }
`;

export const Col = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    flex-basis: 50%;
    align-content: flex-start;
    
      @media (max-width: ${breakpoints.mobile}) {
          width: 100%;
          flex-basis: 100%;
    }
`;

export const ImageCol = styled(Col)`
    @media (max-width: ${breakpoints.mobile}) {
        order: -1;
    }
`;

export const Header = styled.h1`
    margin-top: 50px;
    margin-bottom: 8px;
    ${FONTS.H1};
    color: #fff;
    
    @media (max-width: 1365px) {
      ${FONTS.H3};
    }
    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const Text = styled.div`
    ${FONTS.M}
    color: #fff;
    margin-bottom: 16px;
    
    & ul{
        list-style: disc;
        margin-left: 25px;
    }
    
    @media (max-width: ${breakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const Image = styled.div`
    object-fit: contain;
    width: 100%;
    height: 100%;
    align-content: center;
    @media (max-width: ${breakpoints.mobile}) {
          width: 100%;
          height: auto;
    }
`;

export const ImageBlock = styled(LazyLoadImage)<{ src: string }>`
    background-size: cover;
    width: 100%;
`;

export const Button = styled(BaseButton)`
    width: 165px;
    margin-bottom: 32px;
    @media (max-width: ${breakpoints.mobile}) {
        margin-bottom: 35px;
    }
    
    @media (max-width: ${breakpoints.tablet}) {
        margin-bottom: 50px;
    }
`;
